import React from 'react';

export const BeersZeroState = () => {
  return (
    <svg width="90" height="154" viewBox="0 0 90 154" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14427_89813)">
        <path
          d="M1.41943 95.1302H30.2838C30.5329 118.411 19.8986 141.677 24.8854 152.447C24.8799 153.026 24.4123 153.499 23.8328 153.499H7.87044C7.29088 153.499 6.82416 153.026 6.81874 152.447C11.8055 141.677 1.17118 118.411 1.41943 95.1302Z"
          fill="#C0BFBF"
        />
        <path
          d="M2.41096 96.0311H29.3037C29.3037 120.023 21.1068 135.924 23.156 148.853H8.55865C10.6079 135.924 2.41096 120.023 2.41096 96.0311Z"
          fill="#D4D4D4"
        />
        <path
          d="M14.7624 137.234C14.7624 137.837 15.2508 138.325 15.8529 138.325C16.456 138.325 16.9443 137.837 16.9443 137.234C16.9443 136.633 16.456 136.145 15.8529 136.145C15.2508 136.145 14.7624 136.633 14.7624 137.234Z"
          fill="#D4D4D4"
        />
        <path
          d="M21.3206 121.42C21.3206 122.208 21.9607 122.847 22.7497 122.847C23.5396 122.847 24.1787 122.208 24.1787 121.42C24.1787 120.631 23.5396 119.992 22.7497 119.992C21.9607 119.992 21.3206 120.631 21.3206 121.42Z"
          fill="#F8F8F8"
        />
        <path
          d="M15.8514 153.499H23.8326C24.4121 153.499 24.8797 153.026 24.8852 152.447C23.9355 150.396 23.5518 147.892 23.5527 145.021C23.5536 132.992 30.2863 114.522 30.2881 95.9489C30.2881 95.6757 30.2863 95.4034 30.2836 95.1302H15.8514V96.0309H29.2978C29.2978 120.023 21.1009 135.923 23.1501 148.853H15.8514V153.499Z"
          fill="#999999"
        />
        <path
          d="M15.8573 148.853H23.156C21.1068 135.924 29.3037 120.023 29.3037 96.0311H15.8573V136.145C16.4604 136.145 16.9488 136.633 16.9488 137.234C16.9488 137.837 16.4604 138.325 15.8573 138.325V148.853ZM22.7525 119.991C23.5424 119.991 24.1815 120.63 24.1815 121.419C24.1815 122.207 23.5424 122.846 22.7525 122.846C21.9635 122.846 21.3235 122.207 21.3235 121.419C21.3235 120.63 21.9635 119.991 22.7525 119.991Z"
          fill="#D4D4D4"
        />
        <path
          d="M15.8529 138.325C16.456 138.325 16.9443 137.837 16.9443 137.234C16.9443 136.633 16.456 136.145 15.8529 136.145V138.325Z"
          fill="#D4D4D4"
        />
        <path
          d="M22.7497 122.847C23.5396 122.847 24.1787 122.208 24.1787 121.42C24.1787 120.631 23.5396 119.992 22.7497 119.992C21.9607 119.992 21.3206 120.631 21.3206 121.42C21.3206 122.208 21.9607 122.847 22.7497 122.847Z"
          fill="#D4D4D4"
        />
        <path
          d="M5.59644 96.5374H3.12743C2.81147 111.458 10.0271 131.119 9.64795 148.442C11.04 124.987 5.30666 118.646 5.59644 96.5374Z"
          fill="#F8F8F8"
        />
        <path
          d="M20.8506 112.887C20.8506 113.686 21.2757 114.334 21.7993 114.334C22.3238 114.334 22.749 113.686 22.749 112.887C22.749 112.089 22.3238 111.441 21.7993 111.441C21.2757 111.441 20.8506 112.089 20.8506 112.887Z"
          fill="#D4D4D4"
        />
        <path
          d="M10.0697 110.375C10.0697 111.163 10.7098 111.802 11.4997 111.802C12.2887 111.802 12.9287 111.163 12.9287 110.375C12.9287 109.586 12.2887 108.947 11.4997 108.947C10.7098 108.947 10.0697 109.586 10.0697 110.375Z"
          fill="#D4D4D4"
        />
        <path
          d="M10.5217 105.452C10.5217 106.511 11.3811 107.368 12.4401 107.368C13.4999 107.368 14.3584 106.511 14.3584 105.452C14.3584 104.395 13.4999 103.536 12.4401 103.536C11.3811 103.536 10.5217 104.395 10.5217 105.452Z"
          fill="#D4D4D4"
        />
        <path
          d="M8.88184 145.4C8.88184 146.223 8.5485 148.143 8.38184 149H23.3818L22.8818 145.4C22.8818 145.4 20.3818 144.5 15.8818 145.4C11.3818 146.3 8.88184 145.4 8.88184 145.4Z"
          fill="#FFBF17"
        />
        <ellipse cx="15.8818" cy="95.4998" rx="14.5" ry="1.5" fill="#F8F8F8" />
        <path
          d="M22.3818 93.5292C22.3818 94.8937 21.4864 95.9998 20.3818 95.9998C19.2773 95.9998 18.3818 94.8937 18.3818 93.5292C18.3818 92.1648 20.3818 88.9998 20.3818 88.9998C20.3818 88.9998 22.3818 92.1648 22.3818 93.5292Z"
          fill="#FFBF17"
        />
      </g>
      <path d="M42.2996 2.91364L43.9082 2.91364V11.4642H42.2996V2.91364Z" fill="#595A5A" />
      <path
        d="M34.7283 0L51.4742 0C52.1833 0 52.7578 0.575739 52.7578 1.28637V1.62688C52.7578 2.33587 52.1833 2.91161 51.4742 2.91161L34.7283 2.91161C34.0208 2.91161 33.4463 2.33587 33.4463 1.62688V1.28637C33.4463 0.575739 34.0208 0 34.7283 0Z"
        fill="#B4504F"
      />
      <path
        d="M34.7283 2.91372L51.4742 2.91372C52.1833 2.91372 52.7578 2.33798 52.7578 1.629L33.4463 1.629C33.4463 2.33798 34.0208 2.91372 34.7283 2.91372Z"
        fill="#8F403F"
      />
      <path d="M40.3375 9.54489L45.874 9.54489V11.4646L40.3375 11.4646V9.54489Z" fill="#8C8475" />
      <path d="M48.384 51.2509L81.1553 51.2509L81.1553 138.213H48.384L48.384 51.2509Z" fill="#9E9E9F" />
      <path d="M48.384 85.8577L81.1553 85.8577V108.933H48.384L48.384 85.8577Z" fill="#FAAF3F" />
      <path d="M48.384 85.8577L81.1553 85.8577V89.3187L48.384 89.3187V85.8577Z" fill="#2A2720" />
      <path d="M48.384 105.475L81.1553 105.475V108.936L48.384 108.936V105.475Z" fill="#2A2720" />
      <path
        d="M55.4603 97.3972C55.4603 100.672 59.6263 103.327 64.7673 103.327C69.9066 103.327 74.0742 100.672 74.0742 97.3972C74.0742 94.1221 69.9066 91.4671 64.7673 91.4671C59.6263 91.4671 55.4603 94.1221 55.4603 97.3972Z"
        fill="#EDEEEE"
      />
      <path
        d="M64.7705 138.213H81.1553V108.935H64.7705L64.7705 138.213ZM64.7705 85.8596H81.1553L81.1553 51.2509L64.7705 51.2509V85.8596Z"
        fill="#8F8F8F"
      />
      <path
        d="M64.7676 105.475H81.1523V89.3209H64.7676V91.4676C69.9069 91.4676 74.0745 94.1226 74.0745 97.3977C74.0745 100.673 69.9069 103.328 64.7676 103.328V105.475Z"
        fill="#F89730"
      />
      <path d="M64.7705 85.8577H81.1553V89.3187H64.7705V85.8577Z" fill="#26231D" />
      <path d="M64.7705 105.475H81.1553V108.936H64.7705V105.475Z" fill="#26231D" />
      <path
        d="M64.7673 103.327C69.9066 103.327 74.0742 100.672 74.0742 97.3972C74.0742 94.1221 69.9066 91.4671 64.7673 91.4671V103.327Z"
        fill="#D6D5D5"
      />
      <path
        d="M39.9152 154H89.6162V145.924C89.6162 141.665 86.1708 138.212 81.9212 138.212H47.6103C43.3606 138.212 39.9152 141.665 39.9152 145.924L39.9152 154Z"
        fill="#626363"
      />
      <path
        d="M64.7665 154H89.6162V145.924C89.6162 141.665 86.1708 138.212 81.9212 138.212H64.7665V154Z"
        fill="#595A5A"
      />
      <path
        d="M54.6723 47.0203L75.0983 47.0203C77.4061 47.0203 79.2773 48.8956 79.2773 51.2084V51.2512L50.4932 51.2512V51.2084C50.4932 48.8956 52.3644 47.0203 54.6723 47.0203Z"
        fill="#A38748"
      />
      <path d="M50.0135 52.5946H52.3164L52.3164 136.498H50.0135L50.0135 52.5946Z" fill="white" />
      <path
        d="M61.9514 48H68.3818L68.3818 25.3724C68.3818 17.9992 62.372 12 54.9835 12L31.7801 12C24.3917 12 18.3818 17.9992 18.3818 25.3724L18.3818 30.7287L24.3818 30.5L24.3818 25.3724C24.3818 21.5384 27.9382 18.4189 31.7801 18.4189L54.9835 18.4189C58.8254 18.4189 61.9514 21.5384 61.9514 25.3724L61.9514 48Z"
        fill="#525353"
      />
      <path
        d="M23.6382 15.4226C23.0193 16.0411 22.7452 16.7682 23.0226 17.0478C23.3 17.3258 24.0272 17.0495 24.6444 16.4309C25.2616 15.8124 25.5373 15.0854 25.2583 14.8057C24.9809 14.5277 24.2553 14.8041 23.6382 15.4226Z"
        fill="white"
      />
      <path
        d="M23.3828 38.5294C23.3828 39.8939 22.4874 41 21.3828 41C20.2782 41 19.3828 39.8939 19.3828 38.5294C19.3828 37.1649 21.3828 34 21.3828 34C21.3828 34 23.3828 37.1649 23.3828 38.5294Z"
        fill="#FAAF3F"
      />
      <defs>
        <clipPath id="clip0_14427_89813">
          <rect width="30.9439" height="64.7664" fill="white" transform="matrix(-1 0 0 1 31.3271 89.2337)" />
        </clipPath>
      </defs>
    </svg>
  );
};
